import React, { useEffect, useContext } from 'react';
import { useQuery } from '@apollo/client';

import { Context } from '@store/store';
import { GET_BOOK_DATA } from '@graphql/main';

import styles from './app.module.scss';

import Spinner from './components/spinner';
import ControlBar from './mobile/control-bar';
import TOCSidebar from './mobile/sidebars/toc-sidebar';
import ThumbnailsSidebar from './mobile/sidebars/thumbnails-sidebar';
import BookmarksSidebar from './mobile/sidebars/bookmarks-sidebar';
import PageContainer from './mobile/page-container';
import LoginModal from './mobile/modals/login-modal';
import BetaSidebar from './mobile/sidebars/beta-sidebar';
import ShelfModal from './components/modals/shelf-modal';
import BookmarksModal from './components/modals/bookmarks-modal';
import SearchInput from './mobile/search/search-input';
import MainMenuSidebar from './mobile/main-menu-sidebar';
import SettingsDropdown from './mobile/settings-dropdown';
import SpeechDropdown from './components/speech-dropdown';

const MainMobile = ({ bookId }) => {
  const [, dispatch] = useContext(Context);

  const { loading, error, data } = useQuery(GET_BOOK_DATA, {
    variables: { id: bookId },
  });

  useEffect(() => {
    if (data && data.book) {
      document.title = `${data.book.title}  |  Электронная библиотека Национальной библиотеки РС(Я)`;
      dispatch({
        type: 'SET_IS_USER_LOGGED_IN',
        payload: !!data?.me,
      });
      dispatch({
        type: 'SET_IS_ON_SHELF',
        payload: data.book.is_on_shelf,
      });
      dispatch({
        type: 'SET_PAGES_COUNT',
        payload: data.book.docviewer_htmls_urls.length,
      });
      const initialPage = parseInt((new URLSearchParams(window.location.search)).get('initial-page'));
      if (initialPage > 0) {
        dispatch({
          type: 'SET_CURRENT_PAGE',
          payload: initialPage - 1,
        });
      }
      dispatch({
        type: 'SET_BOOK_IS_ELIGIBLE_FOR_AI_TOOLS',
        payload: data.book.langs.map((x) => x.id).filter(x => ["26"].includes(x)).length > 0,
      });
    }
  }, [data]);

  if (loading) return <Spinner />;
  if (error)
    return (
      <p>
        Ошибка. Пожалуйста перезагрузите вкладку или проверьте ваше
        интернет-соединение.
      </p>
    );
  if (!data.book)
    return <p>Электронного документа с ID {bookId} не существует.</p>;

  return (
    <div className={styles.root}>
      <div style={{ position: 'sticky', top: '0', zIndex: 8000 }}>
        <ControlBar bookId={bookId} />
        <SearchInput
          searchIndexUrl={data.book.search_index_url}
          textByPagesUrl={data.book.text_by_pages_url}
        />
        <SettingsDropdown bookId={bookId} />
      </div>
      {['8888', '12809', '120169'].includes(data.book.id) && <SpeechDropdown
        bookId={bookId}
        editorButtonIsPresent={false}
      />}
      <MainMenuSidebar
        bookTitle={data.book.title}
        bookAuthors={data.book.authors.map(t => t.full_name).join(', ')}
      />
      <TOCSidebar toc={data.book.outline} />
      <ThumbnailsSidebar thumbnails={data.book.docviewer_thumbnails_urls} />
      <BookmarksSidebar />
      <BetaSidebar />
      <PageContainer pages={data.book.docviewer_htmls_urls} bookId={bookId} />
      <LoginModal />
      <BookmarksModal />
      <ShelfModal />
    </div>
  );
};

export default MainMobile;
